<template>
	<v-layout v-if="wasModified() || !isOld">
		<v-flex d-flex xs4>
			<v-card color="grey lighten-1">
				<v-layout row>
					<v-card-text style="padding-right: 8px"><strong>Suma ({{paragraph.name}}) &emsp;{{status()}}</strong>
					</v-card-text>
				</v-layout>
			</v-card>
		</v-flex>
		<v-flex d-flex xs2>
			<v-card :color="(mszFundingsDifferent() ? color() : 'grey') + ' lighten-1'">
				<v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center"><strong>{{formatMoney(paragraph.totalMszFundingsForParagraph)}}</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs2>
			<v-card color="grey lighten-1">
				<v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center">
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs2>
			<v-card :color="(ownFundingsDifferent() ? color() : 'grey') + ' lighten-1'">
				<v-card-text>
					<strong>{{formatMoney(paragraph.totalOwnFundingsForParagraph)}}</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs2>
			<v-card :color="(mszFundingsDifferent() || ownFundingsDifferent() ? color() : 'grey') + ' lighten-1'">
				<v-card-text>
					<strong>{{formatMoney(paragraph.totalFundings)}}</strong>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
	import {Numbers} from "../../../../utils/Numbers";

	export default {
		name: "AgencyCostsSingleParagraph",

		props: {
			paragraph: {},
			otherParagraph: {},
			isOld: {}
		},
		mixins: [Numbers],

		methods: {
			propertiesDifferent(getter) {
				return getter(this.otherParagraph) !== getter(this.paragraph);
			},

			status() {
				return this.wasModified() ? (this.isOld ? "(Było)" : "(Jest)") : '';
			},

			wasModified() {
				return this.mszFundingsDifferent() || this.ownFundingsDifferent();
			},

			paragraphsDifferent() {
				return this.propertiesDifferent(x => x.name);
			},

			mszFundingsDifferent() {
				return this.propertiesDifferent(x => x.totalMszFundingsForParagraph);
			},

			ownFundingsDifferent() {
				return this.propertiesDifferent(x => x.totalOwnFundingsForParagraph);
			},

			color () {
				return this.wasModified() ? "blue" : "gray";
			}
		}
	};
</script>

<style scoped>

</style>